import App from "./App.svelte";
import "./styles/tokens.css";

// Convert path-style deep links (/reset/<token>, /signup/<token>, /setup)
// served via SPA fallback into hash routes so svelte-spa-router picks them up.
const { pathname, hash, search } = window.location;
if (pathname !== "/" && !hash) {
  window.history.replaceState(null, "", "/#" + pathname + search);
}

const app = new App({
  target: document.getElementById("app")!,
});

export default app;
